let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Bq7k")).then(() => parcelRequire('9t7Dt'));